module.exports = __webpack_public_path__ + "static/img/img8.f2dc486.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/content/product/images/img8.jpg
// module id = iCYq
// module chunks = 1